require('./design-system.css');
import { register } from '@servicetitan/web-components';
import { App } from './app';
register(App, false, { legacyRoot: false, sharedDependenciesNames: ["@servicetitan/design-system","@servicetitan/anvil2","classnames","react","react-dom"] });